(function () {
  function initSkyline(canvas) {
    if (canvas.dataset.ccSkylineReady) return;
    canvas.dataset.ccSkylineReady = "true";

    const root = canvas.closest(".cc-home-v8");
    const styles = root ? getComputedStyle(root) : null;
    const accent = styles?.getPropertyValue("--cc-v8-accent").trim() || "#c41e1e";
    const accentGlow = styles?.getPropertyValue("--cc-v8-accent-glow").trim() || "rgba(196, 30, 30, 0.55)";
    const accentMid = styles?.getPropertyValue("--cc-v8-accent-mid").trim() || "#c41e1e";
    const ink = styles?.getPropertyValue("--cc-v8-ink").trim() || "#0e1a26";

    const ctx = canvas.getContext("2d");
    let W = 0;
    let H = 0;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);

    function resize() {
      const r = canvas.getBoundingClientRect();
      W = r.width;
      H = r.height;
      canvas.width = W * DPR;
      canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    function edgeBox(w, h, dp, cx, cy, cz) {
      const hw = w / 2;
      const hh = h / 2;
      const hd = dp / 2;
      const v = [
        [cx - hw, cy - hh, cz - hd],
        [cx + hw, cy - hh, cz - hd],
        [cx + hw, cy + hh, cz - hd],
        [cx - hw, cy + hh, cz - hd],
        [cx - hw, cy - hh, cz + hd],
        [cx + hw, cy - hh, cz + hd],
        [cx + hw, cy + hh, cz + hd],
        [cx - hw, cy + hh, cz + hd],
      ];
      const e = [
        [0, 1],
        [1, 2],
        [2, 3],
        [3, 0],
        [4, 5],
        [5, 6],
        [6, 7],
        [7, 4],
        [0, 4],
        [1, 5],
        [2, 6],
        [3, 7],
      ];
      return e.map(([a, b]) => [v[a], v[b]]);
    }

    function floorSlabs(w, dp, cx, cz, ys) {
      const hw = w / 2;
      const hd = dp / 2;
      const out = [];
      for (const y of ys) {
        out.push([
          [cx - hw, y, cz - hd],
          [cx + hw, y, cz - hd],
        ]);
        out.push([
          [cx + hw, y, cz - hd],
          [cx + hw, y, cz + hd],
        ]);
        out.push([
          [cx + hw, y, cz + hd],
          [cx - hw, y, cz + hd],
        ]);
        out.push([
          [cx - hw, y, cz + hd],
          [cx - hw, y, cz - hd],
        ]);
      }
      return out;
    }

    function facade(w, h, dp, cx, cy, cz, dW, dD) {
      const hw = w / 2;
      const hh = h / 2;
      const hd = dp / 2;
      const out = [];
      for (const z of [cz - hd, cz + hd]) {
        for (let i = 1; i < dW; i++) {
          const x = cx - hw + (i / dW) * w;
          out.push([
            [x, cy - hh, z],
            [x, cy + hh, z],
          ]);
        }
      }
      for (const x of [cx - hw, cx + hw]) {
        for (let i = 1; i < dD; i++) {
          const z = cz - hd + (i / dD) * dp;
          out.push([
            [x, cy - hh, z],
            [x, cy + hh, z],
          ]);
        }
      }
      return out;
    }

    function makeBuildings() {
      let s = [];
      const FH = 1.2;

      const h1 = 2 * FH;
      const w1 = 3.0;
      const d1 = 2.6;
      const cx1 = -5.0;
      const cz1 = 1.4;
      const ys1 = [];
      for (let f = 1; f <= 2; f++) ys1.push(f * FH);
      s = s.concat(edgeBox(w1, h1, d1, cx1, h1 / 2, cz1));
      s = s.concat(facade(w1, h1, d1, cx1, h1 / 2, cz1, 5, 3));
      s = s.concat(floorSlabs(w1, d1, cx1, cz1, ys1));
      s = s.concat(edgeBox(w1 * 0.7, 0.3, d1 * 0.7, cx1, h1 + 0.15, cz1));

      const h2 = 5 * FH;
      const w2 = 3.4;
      const d2 = 3.0;
      const cx2 = -1.5;
      const cz2 = 0.8;
      const ys2 = [];
      for (let f = 1; f <= 5; f++) ys2.push(f * FH);
      s = s.concat(edgeBox(w2, h2, d2, cx2, h2 / 2, cz2));
      s = s.concat(facade(w2, h2, d2, cx2, h2 / 2, cz2, 6, 4));
      s = s.concat(floorSlabs(w2, d2, cx2, cz2, ys2));
      s = s.concat(edgeBox(w2 * 0.7, 0.3, d2 * 0.7, cx2, h2 + 0.15, cz2));

      const h3 = 10 * FH;
      const w3 = 3.6;
      const d3 = 3.2;
      const cx3 = 2.2;
      const cz3 = 0.0;
      const ys3 = [];
      for (let f = 1; f <= 10; f++) ys3.push(f * FH);
      s = s.concat(edgeBox(w3, h3, d3, cx3, h3 / 2, cz3));
      s = s.concat(facade(w3, h3, d3, cx3, h3 / 2, cz3, 7, 4));
      s = s.concat(floorSlabs(w3, d3, cx3, cz3, ys3));
      s = s.concat(edgeBox(2.4, 0.4, 2.0, cx3, h3 + 0.2, cz3));

      const h4 = 18 * FH;
      const w4 = 3.8;
      const d4 = 3.4;
      const cx4 = 6.0;
      const cz4 = -0.8;
      const ys4 = [];
      for (let f = 1; f <= 18; f++) ys4.push(f * FH);
      s = s.concat(edgeBox(w4, h4, d4, cx4, h4 / 2, cz4));
      s = s.concat(facade(w4, h4, d4, cx4, h4 / 2, cz4, 8, 5));
      s = s.concat(floorSlabs(w4, d4, cx4, cz4, ys4));
      s = s.concat(edgeBox(2.8, 0.6, 2.4, cx4, h4 + 0.3, cz4));
      s = s.concat(edgeBox(2.0, 0.4, 1.6, cx4, h4 + 0.8, cz4));

      return s;
    }

    const SEGS_3D = makeBuildings();
    let RIGHT_SEGS = [];

    function project(p, anchorX, anchorY, fov) {
      const camY = 3.0;
      const camZ = 18.0;
      const pitch = 0.1;
      const xc = p[0];
      const yc = p[1] - camY;
      const zc = p[2] - camZ;
      const cs = Math.cos(pitch);
      const sn = Math.sin(pitch);
      const yr = cs * yc - sn * zc;
      const zr = sn * yc + cs * zc;
      if (zr >= -0.1) return null;
      return [anchorX + (xc / -zr) * fov, anchorY - (yr / -zr) * fov];
    }

    function rebuild() {
      RIGHT_SEGS = [];
      const anchorY = H - 2;
      const fov = Math.min(W, 1100) * 0.55;
      const rightAX = W * 0.78;

      const indexed = SEGS_3D.map((seg, i) => {
        const yAvg = (seg[0][1] + seg[1][1]) / 2;
        return { seg, yAvg, i };
      });
      indexed.sort((a, b) => a.yAvg - b.yAvg);

      const total = indexed.length;
      const totalBuild = 11.0;
      const segDur = 0.9;
      const stagger = (totalBuild - segDur) / Math.max(1, total - 1);

      indexed.forEach((item, k) => {
        const p1R = project(item.seg[0], rightAX, anchorY, fov);
        const p2R = project(item.seg[1], rightAX, anchorY, fov);
        const delay = k * stagger;
        if (p1R && p2R) RIGHT_SEGS.push({ p1: p1R, p2: p2R, delay, duration: segDur });
      });
    }

    function clipRectLine(x1, y1, x2, y2, xmin, ymin, xmax, ymax) {
      const dx = x2 - x1;
      const dy = y2 - y1;
      const p = [-dx, dx, -dy, dy];
      const q = [x1 - xmin, xmax - x1, y1 - ymin, ymax - y1];
      let u1 = 0;
      let u2 = 1;
      for (let i = 0; i < 4; i++) {
        if (p[i] === 0) {
          if (q[i] < 0) return null;
        } else {
          const t = q[i] / p[i];
          if (p[i] < 0) {
            if (t > u2) return null;
            if (t > u1) u1 = t;
          } else {
            if (t < u1) return null;
            if (t < u2) u2 = t;
          }
        }
      }
      return [x1 + u1 * dx, y1 + u1 * dy, x1 + u2 * dx, y1 + u2 * dy];
    }

    function drawSeg(p1, p2, color, alpha = 1, glow = false) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.strokeStyle = color;
      ctx.lineWidth = glow ? 1.4 : 1;
      if (glow) {
        ctx.shadowColor = color;
        ctx.shadowBlur = 6;
      }
      const c = clipRectLine(p1[0], p1[1], p2[0], p2[1], 0, 0, W, H);
      if (c) {
        ctx.beginPath();
        ctx.moveTo(c[0], c[1]);
        ctx.lineTo(c[2], c[3]);
        ctx.stroke();
      }
      ctx.restore();
    }

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    const BUILD_SECS = 11.0;
    const TOTAL_SECS = BUILD_SECS + 1.5;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const startTime = performance.now() / 1000 - (reduceMotion ? TOTAL_SECS : 0);

    function animate() {
      ctx.clearRect(0, 0, W, H);
      const t = performance.now() / 1000 - startTime;

      function renderSide(segs, finalColor) {
        for (const s of segs) {
          const localT = t - s.delay;
          if (localT <= 0) continue;

          if (localT < s.duration) {
            const p = easeInOut(localT / s.duration);
            const tipX = s.p1[0] + (s.p2[0] - s.p1[0]) * p;
            const tipY = s.p1[1] + (s.p2[1] - s.p1[1]) * p;
            ctx.save();
            ctx.shadowColor = accentGlow;
            ctx.shadowBlur = 14;
            ctx.strokeStyle = accentGlow;
            ctx.lineWidth = 2.2;
            const c1 = clipRectLine(s.p1[0], s.p1[1], tipX, tipY, 0, 0, W, H);
            if (c1) {
              ctx.beginPath();
              ctx.moveTo(c1[0], c1[1]);
              ctx.lineTo(c1[2], c1[3]);
              ctx.stroke();
            }
            ctx.restore();
            drawSeg(s.p1, [tipX, tipY], accentMid, 1, false);
          } else {
            const sinceSettle = localT - s.duration;
            if (sinceSettle < 0.18) {
              const f = sinceSettle / 0.18;
              drawSeg(s.p1, s.p2, finalColor, 0.4 + 0.6 * f, false);
              drawSeg(s.p1, s.p2, accentGlow, (1 - f) * 0.7, false);
            } else {
              drawSeg(s.p1, s.p2, finalColor, 1, false);
            }
          }
        }
      }

      renderSide(RIGHT_SEGS, ink);

      if (t < TOTAL_SECS) {
        requestAnimationFrame(animate);
      } else {
        ctx.clearRect(0, 0, W, H);
        for (const s of RIGHT_SEGS) drawSeg(s.p1, s.p2, ink, 1, false);
      }
    }

    resize();
    rebuild();
    animate();
    window.addEventListener("resize", () => {
      if (!canvas.isConnected) return;
      resize();
      rebuild();
      if (performance.now() / 1000 - startTime >= TOTAL_SECS) {
        for (const s of RIGHT_SEGS) drawSeg(s.p1, s.p2, ink, 1, false);
      }
    });
  }

  function initAll(scope) {
    scope.querySelectorAll("[data-cc-home-v8-canvas]").forEach(initSkyline);
  }

  initAll(document);
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
